<!-- src/apps/secret/components/layout/SecretFooterAttribution.vue -->

<script setup lang="ts">
  import { NEUTRAL_BRAND_DEFAULTS } from '@/shared/constants/brand';
  import { useBootstrapStore } from '@/shared/stores/bootstrapStore';
  import { storeToRefs } from 'pinia';
  import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { brand_product_name } = storeToRefs(useBootstrapStore());

  defineProps<{
    siteHost: string;
    showNav?: boolean;
    showTerms?: boolean;
  }>();
</script>

<template>
  <footer
    class="text-center text-xs text-day-ink-faint dark:text-night-ink-faint"
    role="contentinfo">
    <nav
      v-if="showNav"
      class="flex flex-wrap justify-center gap-2 space-x-2"
      :aria-label="t('web.layout.footer_navigation')">
      <a
        :href="`https://${siteHost}`"
        class="hover:underline focus:ring-2 focus:ring-brand-500 focus:outline-none"
        rel="noopener noreferrer"
        target="_blank"
        :aria-label="t('web.layout.visit_onetime_secret_homepage', { product_name: brand_product_name ?? NEUTRAL_BRAND_DEFAULTS.product_name })">
        {{ t('web.branding.powered_by_onetime_secret', { product_name: brand_product_name ?? NEUTRAL_BRAND_DEFAULTS.product_name }) }}
      </a>

      <template v-if="showTerms">
        <span
          aria-hidden="true"
          class="text-day-ink-faint dark:text-night-ink-faint"
          role="presentation">&middot;</span>
        <router-link
          to="/info/terms"
          class="hover:underline focus:ring-2 focus:ring-brand-500 focus:outline-none"
          :aria-label="t('web.layout.view_terms_of_service')">
          {{ t('web.footer.terms') }}
        </router-link>
        <span
          aria-hidden="true"
          class="text-day-ink-faint dark:text-night-ink-faint"
          role="presentation">&middot;</span>
        <router-link
          to="/info/privacy"
          class="hover:underline focus:ring-2 focus:ring-brand-500 focus:outline-none"
          :aria-label="t('web.layout.view_privacy_policy')">
          {{ t('web.footer.privacy') }}
        </router-link>
      </template>
    </nav>

    <div
      v-else
      class="text-center">
      <a
        :href="`https://${siteHost}`"
        class="inline-block px-2 py-1 text-[0.7rem] text-day-ink-faint transition-colors duration-200
          hover:text-brand-600 hover:underline focus:ring-2 focus:ring-brand-500 focus:outline-none
          dark:text-night-ink-faint dark:hover:text-brand-500"
        rel="noopener noreferrer"
        target="_blank"
        :aria-label="t('web.layout.visit_onetime_secret_homepage', { product_name: brand_product_name ?? NEUTRAL_BRAND_DEFAULTS.product_name })">
        {{ t('web.branding.powered_by_onetime_secret', { product_name: brand_product_name ?? NEUTRAL_BRAND_DEFAULTS.product_name }) }}
      </a>
    </div>
  </footer>
</template>
